import React from 'react';
import { prettyTime } from 'utils';

export const DurationMask = ({ duration }) => <span className="ct-duration-mask">{prettyTime(duration)}</span>;
